import React from "react";
import { useNavigate } from "react-router-dom";

import { ErrorBoundary } from "igfd-ui/src/app-index";

export const NavigableErrorBoundary = ({
  children,
}: React.PropsWithChildren<{}>) => {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  return <ErrorBoundary goBack={goBack}>{children}</ErrorBoundary>;
};
